import React from 'react';
import { connect } from 'react-redux';
import { updateHttpStatus as dispatchUpdateHttpStatus } from '../../actions/httpStatus';
import { Error } from './Error';

const ERROR_HTTP_STATUS = 500;

class NotFoundContainer extends React.Component {
    constructor(props) {
        super(props);

        const { shouldDispatchHttpStatus, updateHttpStatus } = this.props;

        // this will for now only be used by Contento views
        if (shouldDispatchHttpStatus) {
            updateHttpStatus();
        }
    }

    render() {
        // eslint-disable-next-line react/jsx-props-no-spreading
        return <Error {...this.props} />;
    }
}

const mapDispatchToProps = (dispatch) => ({
    updateHttpStatus: () => dispatch(dispatchUpdateHttpStatus(ERROR_HTTP_STATUS)),
});

export default connect(null, mapDispatchToProps)(NotFoundContainer);
